import { BodyText, Gutter, Input } from '@gaiads/telia-react-component-library';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PopupModal } from '@cdaas/reusable-components-daas';
import { AdminProductVariant, Country } from '@cdaas/api-clients/dist/product-service-openapi';

import { getVariantMaterials } from '../../../utils/products';
import MaterialCodeVariantDetails from '../MaterialCodeVariantDetails/MaterialCodeVariantDetails';

import './MaterialCodeEditModal.scss';

interface MaterialCodeEditModalProps {
  variant?: AdminProductVariant;
  variantPropertyValues?: Record<number, string[]>;
  productName?: string;
  countryId: number;
  countries: Country[];
  onAction: (code?: string) => void;
  onClose: () => void;
}

const MaterialCodeEditModal = ({
  variant,
  variantPropertyValues,
  productName,
  countryId,
  countries,
  onAction,
  onClose,
}: MaterialCodeEditModalProps) => {
  const { t } = useTranslation('productscreen');
  const [code, setCode] = useState<string>();

  useEffect(() => {
    const materialCodes = getVariantMaterials(countryId, variant);
    const newMaterialCode = materialCodes?.[0]?.code;
    setCode(newMaterialCode);
  }, [countryId, variant]);

  return (
    <PopupModal
      translations={{
        heading: t('materialCodeEditModal.heading'),
        actionButton: t('materialCodeEditModal.saveChanges'),
        closeButton: t('materialCodeEditModal.cancel'),
      }}
      onAction={() => onAction(code)}
      onClose={onClose}
      hidden={!variant}
    >
      {variant && (
        <>
          <MaterialCodeVariantDetails
            variant={variant}
            variantPropertyValues={variantPropertyValues}
            productName={productName}
            countryId={countryId}
            countries={countries}
            showMaterialCode={false}
          />
          <Gutter />
          <Input
            label={t('materialCodeEditModal.materialCodeInputLabel')}
            value={code}
            onChange={(_event, value) => setCode(value)}
            className="material-code-edit-modal__material-code-input"
            errorText={!code ? t('materialCodeEditModal.missingMaterialCodeError') : undefined}
          />
          <Gutter />
          <BodyText>{t('materialCodeEditModal.paragraph1')}</BodyText>
          <BodyText>
            <Trans
              t={t}
              i18nKey="materialCodeEditModal.paragraph2"
              components={{
                a: <a href={process.env.REACT_APP_COLT_URL} target="_blank" rel="noreferrer" />,
              }}
            />
          </BodyText>
          <BodyText>
            <Trans
              t={t}
              i18nKey="materialCodeEditModal.paragraph3"
              components={{
                strong: <strong />,
              }}
            />
          </BodyText>
        </>
      )}
    </PopupModal>
  );
};

export default MaterialCodeEditModal;
